import { useEffect } from "react";

const KEY = "weather_notif_v1";

export function useWeatherNotifier(alert) {
  useEffect(() => {
    if (!alert || typeof window === "undefined" || !("Notification" in window)) return;
    if (Notification.permission === "default") {
      Notification.requestPermission().catch(() => {});
      return;
    }
    if (Notification.permission !== "granted") return;
    // Throttle: fire once per alert-type per day
    const dayKey = `${alert.icon}_${new Date().toDateString()}`;
    let last = "";
    try { last = localStorage.getItem(KEY) || ""; } catch { return; }
    if (last === dayKey) return;

    const title = `${alert.icon} My Expenses`;
    const opts = {
      body: alert.text,
      icon: "/icons/icon-192.png",
      badge: "/icons/icon-192.png",
      tag: "weather-alert",
      renotify: true,
      lang: /[\u0600-\u06FF]/.test(alert.text) ? "ar" : "en",
    };
    const fireBasic = () => { try { new Notification(title, opts); } catch { /* ignore */ } };
    if ("serviceWorker" in navigator && navigator.serviceWorker.ready) {
      navigator.serviceWorker.ready
        .then((reg) => reg.showNotification(title, opts))
        .catch(fireBasic);
    } else fireBasic();
    try { localStorage.setItem(KEY, dayKey); } catch { /* ignore */ }
  }, [alert?.icon, alert?.text]);
}
